/* eslint-disable */ 

import axios from 'axios';

const SERVICE = "/identidade";

export default {    
    autenticar: ({ commit }, payload) => {
        return axios.post(SERVICE + "/autenticar/painel", payload)  
                    .then(resp => resp.data);                    
    },
    perfil: ({commit}, payload) => {
        return axios.post(SERVICE + "/perfil", payload)  
                    .then(resp => resp.data);                    
    },
    alterarSenha: ({commit}, payload) => {        
        return axios.post(SERVICE + "/alterar-senha", payload)  
                    .then(resp => resp.data);                    
    },
    solicitarNovaSenha: ({commit}, payload) => {        
        return axios.post(SERVICE + `/solicitar-nova-senha?cpf=${payload}`)  
                    .then(resp => resp.data);                    
    },
    resetarSenha: ({commit}, payload) => {        
        return axios.post(SERVICE + "/resetar-senha?idRequisicao=" + payload)  
                    .then(resp => resp.data);                    
    },    
}